import React from "react"
import Lottie from "@shared/uiNew/LazyLottie"

import FeatureCardsSection from "@shared/uiNew/FeatureCardsSection"

import lineAnimation from "@/shared/animations/underline.json"
import start_1 from "../assets/start_1.png"
import start_2 from "../assets/start_2.webp"
import start_3 from "../assets/start_3.png"
import start_4 from "../assets/start_4.png"

import * as styles from "../styles.module.scss"

const Start = (props) => (
  <FeatureCardsSection
    title={title}
    // bubble={marketingBubble}
    cards={startArray}
    bgColor="#fff"
    buttonProps={{
      text: "Оставить заявку на демо",
      icon: "arrow",
      style: styles.startButton,
    }}
  />
)

export default Start

const title = (
  <h1 className={styles.startTitle}>
    <span className={styles.startHighlight}>
      Как запустить
      <Lottie animationData={lineAnimation} loop={false} autoplay />
    </span>{" "}
    онлайн-чат
  </h1>
)

const startArray = [
  {
    id: 1,
    title: "Установить код на сайт",
    step: <span className={`${styles.startStep} h2`}>Шаг 1</span>,
    text: "Установите код Carrot quest на ваш сайт или приложение, чтобы начать собирать данные.",
    image: start_1,
    imageAlt: "Установить код на сайт",
  },
  {
    id: 2,
    title: "Настройте мессенджеры",
    step: <span className={`${styles.startStep} h2`}>Шаг 2</span>,
    text: "Telegram, МАХ, ВКонтакте и другие — клиент пишет там, где ему удобно, а все диалоги приходят в единый интерфейс оператора.",
    image: start_2,
    imageAlt: "Настройте мессенджеры",
  },
  {
    id: 3,
    title: "Настройте AI-бота для автоматизации",
    step: <span className={`${styles.startStep} h2`}>Шаг 3</span>,
    text: "Загрузите базу знаний или укажите ссылку на сайт — бот начнет отвечать на типовые вопросы, пока операторы заняты приоритетными задачами.",
    image: start_3,
    imageAlt: "Настройте AI-бота для автоматизации",
  },
  {
    id: 4,
    title: "Анализируйте и улучшайте показатели",
    step: <span className={`${styles.startStep} h2`}>Шаг 4</span>,
    text: "Отслеживайте эффективность менеджеров, их загруженность, а также темы диалогов, источники обращений, оценки от клиентов. Оптимизируйте работу команды и отслеживайте результативность.",
    image: start_4,
    imageAlt: "Анализируйте и улучшайте показатели",
  },
]
